import {useEffect, useState} from "react";

/*
 * returns delayed value: `delay` ms względem `value`.
 * good for searching (np. search), to stop requesting BE too many times
 */
const useDebouncedValue = <T>(value: T, delay = 300): T => {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
       const timer = setTimeout(() => {
           setDebouncedValue(value);
       }, delay);

       return () => {
           clearTimeout(timer);
       }
    }, [value, delay]);

    return debouncedValue;
};

export default useDebouncedValue;